import AdminView from './AdminView';
import UserContractorView from './UserContractorView';
import { useRole } from '../../../hooks/useRole';

export default function BulkRequests() {
	const { isAdmin, isStaff } = useRole();
	return isAdmin || isStaff ? <AdminView /> : <UserContractorView />;
}
